/**
 * Relay for Projects
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const ProjectsQuery = graphql`
  query project_Query($id: ID!, $isDefaultRoute: Boolean!) {
    viewer{
      ...project_viewer
    }
  }
`;

export const SharedProjectPageQuery = graphql`
  query project_sharedProject_Query($opaque_id: String!) {
    viewer{
      ...projectShared_viewer
    }
  }
`;

export const ProjectListFragment = graphql`
  fragment projectList_viewer on Viewer {
    projects(first: 100, scope: CurrentUser) {
      edges{
        node{
          ...projectNode @relay(mask: false)
        }
      }
    }
  }
`;

export const ShareProjectFragment = graphql`
  fragment projectShared_viewer on Viewer {
    profile{
      user_id
    }
    shared_project(opaque_id: $opaque_id) {
      ...projectNodeWithTracks @relay(mask: false)
    }
  }
`;

export const ProjectPageFragment = graphql`
  fragment project_viewer on Viewer {
    latest_project{
      ...projectNodeWithTracks @relay(mask: false)
    }
    projects(first: 100, scope: CurrentUser) @connection(key: "list_projects", filters: []) {
      edges{
        node{
          ...projectNode @relay(mask: false)
        }
      }
    }
    node(id: $id) @skip(if: $isDefaultRoute) {
      ... on Project {
        ...projectNodeWithTracks @relay(mask: false)
      }
    }
    selected_currency
  }
`;

export const ProjectNode = graphql`
  fragment projectNode on Project {
    id
    is_public
    name
    notes
    tracks(first: 100) @connection(key: "project_tracks") {
      edges {
        id
      }
    }
    owner{
      id
      first_name
      last_name
      user_id
    }
    users{
      id
      first_name
      last_name
      user_id
      role
    }
    license_params{
      spot_count
      term
      medium
      contextual_param
      contextual_param_type
    }
  }
`;

export const ProjectNodeWithTracks = graphql`
  fragment projectNodeWithTracks on Project {
    id
    is_public
    name
    notes
    opaque_id
    tracks(first: 100) @connection(key: "project_tracks") {
      edges {
        id
        version
        node {
          ...trackNode @relay(mask: false)
        }
      }
    }
    owner{
      id
      first_name
      last_name
      user_id
    }
    users{
      id
      first_name
      last_name
      user_id
      role
    }
    license_params{
      spot_count
      term
      medium
      contextual_param
      contextual_param_type
    }
  }
`;

export const CreateProjectMutation = graphql`
  mutation projectCreate_Mutation($input: CreateProjectInput!) {
    createProject(input: $input) {
      new_project_edge {
        node {
          id
          name
          tracks(first: 100) @connection(key: "project_tracks") {
            edges {
              id
            }
          }
        }
      }
    }
  }
`;

export const DeleteProjectMutation = graphql`
  mutation projectDelete_Mutation($input: DeleteProjectInput!) {
    deleteProject(input: $input) {
      deleted_id
      deleted_count
    }
  }
`;

export const UpdateProjectMutation = graphql`
  mutation projectUpdate_Mutation($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      project{
        id
        is_public
        name
        tracks(first: 100) @connection(key: "project_tracks") {
          edges {
            id
            version
            node {
              ...trackNode @relay(mask: false)
            }
          }
        }
        license_params{
          spot_count
          term
          medium
          contextual_param
          contextual_param_type
        }
      }
    }
  }
`;

export const JoinProjectMutation = graphql`
  mutation projectJoin_Mutation($input: JoinProjectInput!) {
    joinProject(input: $input) {
      project{
        id
        name
        users{
          id
          user_id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/project.ts